module.exports = __webpack_public_path__ + "static/media/search-icon.3006598c.svg";